import { CalendarsEntityModel } from "src/store/models/entity/calendars/entity";
import { CalendarsHelperModel } from "src/store/models/entity/calendars/helper";

export const encooCalendarsModels = {
  entity: CalendarsEntityModel,
  helper: CalendarsHelperModel,
};
